/* eslint-disable no-restricted-syntax */
import { Component } from 'react';
import { compose } from 'recompose';
import { getProductsDiscount } from '../Providers/ProductsDiscountApi';
import { voucherExpired, getAmountAfterDiscount, getCurrencyAmount } from '../Helpers/SlashPrice/SlashPriceHelper';
import { withTranslationProvider } from '../Translations';
import { getProductTemplateCode } from '../Helpers/CategoryPagePreview/CategoryPagePreviewHelper';
import categoryPagePreviewEnabled from '../Helpers/CategoryPagePreview/CategoryPagePreviewEnabled';
import slashPriceEnabled from '../Helpers/SlashPrice/SlashPriceEnabled';
import { issuuList } from '../../IssuuPreview/PreviewData';
import { withJustInTimeProductDetail } from '../GTM/withDataLayerProductDetail';
import { withPdpPreview } from '../../IssuuPreview/withPdpPreview';
import { withStoreDetail } from '../Providers/WithStoreDetail';
import { urlContains } from '../../Common/Helpers/UrlHelper';

class CategoryPage extends Component {
  constructor(props){
    super(props)
    this.state = {
      categoryPagePreviewEnabled: false,
      slashPriceObject: {},
      slashPriceEnabled: false,
      isFromMyVoucher: false
    }
  }

  componentDidMount() {
    categoryPagePreviewEnabled().then((previewConfig) => this.setState({categoryPagePreviewEnabled: previewConfig}) );
    slashPriceEnabled().then((slashConfig) => {
      if (this.props.productFamilyId && slashConfig) {
        getProductsDiscount([this.props.productFamilyId])
        .then((slashPriceVoucher) => {
          this.setState({ 
            slashPriceObject: slashPriceVoucher.data,
            slashPriceEnabled: slashConfig
          });
        })
      }
    })
  
    const appElement = document.getElementById('app');

    const observerConfig = {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    };
    const callback = () => {
      if (document.querySelectorAll('.ProductsList .BaseList').length > 0) {
        this.formatProductLink();
        if (this.state.slashPriceEnabled) {
          this.applySlashPrice();
        }
        if (this.state.categoryPagePreviewEnabled) {
          this.applyPreview();
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(appElement, observerConfig);
  }

  formatProductLink = () => {
    let currentURL = window.location.href;
    const anchorElements = document.querySelectorAll('.ProductsList .BaseList .ProductView');
  
    if (anchorElements.length > 0) {
      if (this.state.isFromMyVoucher && !urlContains('page_from=my_voucher')) {
        let newUrl = currentURL + '&page_from=my_voucher';
        window.history.pushState({ path: newUrl }, '',newUrl);
      }
      if (urlContains('page_from=my_voucher')) {
        if (anchorElements.length > 0) {
          this.setState({ 
            isFromMyVoucher: true
          });
          anchorElements.forEach(function (element) {
            if (element.href) {
              let currentHref = element.href;
              let url = new URL(currentHref);
              let pathArray = url.pathname.split('/');
              if (pathArray[pathArray.length - 1] !== 'editor') {
                  let productId = pathArray.pop();
                  pathArray.push('editor');
                  url.searchParams.set('productId', productId);
                  url.searchParams.delete('page_from');
                  url.pathname = pathArray.join('/');
                  element.href = url.href;
      
                  element.addEventListener('click', () => {
                    window.location.href = url.href;
                });
              }
            } 
          });
        }
      }
    }
  }

  applyPreview = () => {
    if (!document.querySelector('.ProductsList .BaseList .pb-preview-node')) {
      const products = document.querySelectorAll('.ProductsList .BaseList .ProductView');
      for (const product of products) {
        const friendlyUrl = product.href || '';
        if (friendlyUrl !== '') {
          const productTemplateCode = getProductTemplateCode(friendlyUrl);
          if (productTemplateCode) {
            this.generatePreviewButton(product, productTemplateCode, friendlyUrl);
          }
        }
      }
    }
  }

  generatePreviewButton = (product, productTemplateCode, friendlyUrl) => {
    const templateOrientation = issuuList[productTemplateCode].square ? 'square' : 'default';
    const createA = document.createElement('button');
    createA.setAttribute('class', 'text-center pb-preview-node btn btn-link mt-2 mb-1');
    createA.innerHTML += `<i class="fa fa-search-plus"></i><span class="ml-2 ProximaNova-Bold">${this.props.t('footer.issuupreview_preview', 'PREVIEW')} </span>`;
    createA.onclick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.props.setSelectedType({ insertedType: templateOrientation });
      this.props.setProductDetail({ attributeValues: { theme: productTemplateCode, friendlyUrl } });
      this.props.setOpen(true);
      this.props.setGalleryFound(true);
    };

    const newProduct = product;
    newProduct.style.paddingBottom = '0px';
    newProduct.append(createA);
  }

  applySlashPrice = () => {
    const {
      productFamilyId,
      t,
      store: {
        currency: {
          decimal_places: decimalPlaces
        }
      }
    } = this.props;
    const prices = document.querySelectorAll('.PriceView');

    if (prices.length === 0) return;

    if (!this.state.slashPriceObject[productFamilyId] ||
      voucherExpired(this.state.slashPriceObject[productFamilyId].expiry_date)) return;

    const discountRate = this.state.slashPriceObject[productFamilyId].discount_percentage / 100;
    prices.forEach((price) => {
      if (!price.innerText || (price.children[0] && price.children[0].className === 'applied')) return;

      const [currency, amount, currencyOnRight] = getCurrencyAmount(price.innerText);

      const amountAfterDiscount = getAmountAfterDiscount(amount, discountRate, decimalPlaces);
      const copiedPrice = price;
      currencyOnRight ?
        copiedPrice.innerHTML = `<span class="applied">${t('footer.categorypage_slashprice_from', 'From')} <s>${copiedPrice.innerText}</s></span>
        <span style="color: #f56701">${amountAfterDiscount} ${currency}</span>` :
        copiedPrice.innerHTML = `<span class="applied">${t('footer.categorypage_slashprice_from', 'From')} <s>${copiedPrice.innerText}</s></span>
        <span style="color: #f56701">${currency} ${amountAfterDiscount}</span>`;
    });
  }

  render() {
    return null;
  }
}

const enhance = compose(
  withJustInTimeProductDetail,
  withPdpPreview,
  withTranslationProvider,
  withStoreDetail
);

export default enhance(CategoryPage);
export const undecorated = CategoryPage;



// WEBPACK FOOTER //
// ./src/Common/Editor/CategoryPage.js